import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "corrugated-container-manufacturers",
  "title": "Corrugated Container Manufacturers",
  "summary": "Baling and handling for corrugated, box board trim, small cartons, and packaging scrap.",
  "image": "equipment/horizontal-balers/horizontal-1.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['corrugated-container-manufacturers'];


function CorrugatedContainerManufacturers() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"C+M open-end automatic tie balers are frequently described for trimmed or shredded corrugated, box board trim, small cartons, and packaging production scrap."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Corrugated and Box Board Trim</h3>
              <div className="body-copy">C&amp;M <strong>open-end automatic tie balers</strong> are frequently described for trimmed or shredded corrugated, box board trim, small cartons, and packaging production scrap.</div>
              <div className="body-copy">Wide-mouth automatic balers are useful when boxes or bulk OCC need larger <strong>infeed openings</strong> and consistent automatic bale discharge.</div>
              <div className="detail-points">
                <div className="detail-point">OCC and box board trim</div>
                <div className="detail-point">Small cartons and packaging scrap</div>
                <div className="detail-point">Wide-mouth automatic options for bulky material</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default CorrugatedContainerManufacturers;
